import { Link } from "react-router-dom";
import { BRAND } from "@/lib/api";

const STORY = "https://images.unsplash.com/photo-1568909555141-aebfc970e8d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function OurStory() {
  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
      <div className="text-center max-w-2xl mx-auto">
        <span className="gh-overline">Our Story</span>
        <h1 className="font-heading text-5xl sm:text-6xl text-[#3A3632] mt-4">It began with a single note.</h1>
        <div className="gh-hairline my-7 max-w-[120px] mx-auto" />
      </div>
      <div className="flex justify-center mt-10 gh-fade-up">
        <div className="gh-frame overflow-hidden max-w-3xl w-full">
          <img src={STORY} alt="A handwritten note" className="w-full h-[440px] object-cover" />
          <div className="absolute inset-0 bg-[#FAF7F2] mix-blend-soft-light opacity-30 pointer-events-none" />
        </div>
      </div>
      <div className="max-w-2xl mx-auto mt-14 text-lg text-[#6B655F] leading-relaxed font-light space-y-6">
        <p>Hope &amp; Favor was founded by <span className="text-[#3A3632] font-normal">{BRAND.owner}</span> on a quiet conviction: that small acts of kindness, offered at the right moment, can carry someone through their hardest days.</p>
        <p>What started as handwritten notes and care packages for friends in difficult seasons slowly grew into something more — a way to help anyone send comfort, encouragement, and hope to the people they love.</p>
        <p>Today, every Hope &amp; Favor box is still assembled by hand and finished with a signature Hope Card. Because we believe the people who receive them deserve to feel seen, encouraged, and supported — never sold to.</p>
        <p className="font-hand text-3xl text-[#C4A4A4]">With gratitude, Hope &amp; Favor</p>
      </div>
      <div className="text-center mt-14">
        <Link to="/shop" data-testid="story-shop-btn" className="btn-primary">Send a little hope</Link>
      </div>
    </div>
  );
}
